import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/style/reset.less';
import store from '../../store/index';
import { Lazyload } from 'vant';
import { initSLS } from '@/utils/sls';
import '@/assets/style/animate.css';

const app = createApp(App);
app.use(store).use(Lazyload);
app.mount('#app');
initSLS(app);
